import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Checkbox,
  Tooltip,
  Modal,
  Spin,
  message,
  Form,
  Input,
  Avatar,
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import { MdOutlineDone } from "react-icons/md";
import IndivisualPage from "./BuyerList";
import "./Indivisual.css";

import ErrorLogout from "../../../helpers/ErrorLogout";
import Pagination from "../../common/Pagination";
import { BsEye } from "react-icons/bs";
import IndividualDrawer from "./drawer/IndividualDrawer";
import { getVerifyBuyerRequest, rejectBuyerVerification, verifyBuyer } from "../../../api/AdminRequest";

const { TextArea } = Input;
const VarifyRequest = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showIndivisualPage, setShowIndivisualPage] = useState(false);

  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(5);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [trigger, setTrigger] = useState(false);
  const [searchName, setSearchName] = useState("");
  const [user, setUser] = useState([]);
  const [currentUser, setCurrentUser] = useState("");
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [rejectingUser, setRejectingUser] = useState(null);
  const tabs = [
    { label: "Requests", value: "requested" },
    { label: "Rejected", value: "rejected" },
  ];
  const [activeTab, setActiveTab] = useState("requested"); // Update initial state to 'all'
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [form] = Form.useForm();

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleOpenIndivisualPage = () => {
    setShowIndivisualPage(true);
  };
  const handleLimit = (e) => {
    const searchName = parseInt(e.target.value); // Convert value to integer if needed
    setLimit(searchName); // Update state with the selected value
    setCurrentPage(1);
  };

  useEffect(() => {
    const bidsCall = async () => {
      try {
        setLoader(true);
        const { data } = await getVerifyBuyerRequest({
          q: searchName,
          page: currentPage,
          limit: limit,
          idVerificationStatus: activeTab,
        });

        if (data?.success) {
          // console.log(data);

          setUser(data?.users);
          setTotalPages(data?.totalPages);
          setCurrentPage(data?.currentPage);
          setTotalItems(data?.totalItems);
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);

        console.log(error);
        console.log(error.message);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      }
    };
    bidsCall();
  }, [limit, currentPage, trigger, activeTab]);

  // ------- VERFY USER---------------
  const showConfirm = (user) => {
    Modal.confirm({
      title: "Are you sure you want to verify this user?",

      onOk() {
        VerifyUser(user._id, "verified", user.name);
      },
      onCancel() {
        console.log("Verification cancelled");
      },
    });
  };

  const VerifyUser = async (id, status, name) => {
    try {
      const { data } = await verifyBuyer(id);
      // console.log(data);

      if (data.success) {
        closeDrawer()

        setCurrentUser({ name });
        setIsModalOpen(true);
        setTrigger(!trigger); // Trigger a re-fetch of the user list
      } else {
        message.error("Verification failed. Please try again.");
      }
    } catch (error) {
      console.error("Error verifying user:", error);
      message.error("An error occurred while verifying the user.");
    }
  };

  // ------------------ REJECT USER----------
  const showRejectConfirm = (user) => {
    setRejectingUser(user);
    closeDrawer()

    setIsRejectModalOpen(true);
    form.resetFields();
  };

  const handleRejectCancel = () => {
    setIsRejectModalOpen(false);
    setRejectingUser(null);
    form.resetFields();
  };

  const handleReject = async () => {
    try {
      const values = await form.validateFields();
      const { data } = await rejectBuyerVerification(
        rejectingUser._id,
        values.rejectReason
      );
      if (data.success) {
        closeDrawer()
        message.success(
          `${rejectingUser.name}'s verification request has been rejected.`
        );
        setTrigger(!trigger); // Trigger a re-fetch of the user list
        handleRejectCancel();
      } else {
        message.error("Rejection failed. Please try again.");
      }
    } catch (error) {
      if (error.errorFields) {
        return; // Form validation error, don't proceed
      }
      console.error("Error rejecting user:", error);
      message.error("An error occurred while rejecting the user.");
    }
  };

  // -------------- DRAWER -----------------
  const showDrawer = (record) => {
    setSelectedUser(record);
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
    setSelectedUser(null);
  };

  if (showIndivisualPage) {
    return <IndivisualPage />;
  }

  const columns = [
    {
      title: () => <Checkbox />,
      key: "select",
      render: () => <Checkbox />,
      width: 50,
    },
    {
      title: "Buyer Name",
      dataIndex: "name",
      key: "name",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Avatar
            icon={<UserOutlined />}
            src={record.profileImage}
            style={{ marginRight: "8px" }}
          />
          {record.name}
        </div>
      ),
    },

    {
      title: (
        <div className="flex text-[13px] items-center gap-2">Email id</div>
      ),
      dataIndex: "email",
      key: "email",
      render: (text) => (
        <span className="text-[#1955EB] text-[12px] font-medium">{text}</span>
      ),
    },
    {
      title: (
        <div className="flex text-[13px] items-center gap-2">Phone Number</div>
      ),
      dataIndex: "phone",
      key: "phone",
      render: (text) => (
        <span className="text-[#1955EB] text-[12px] font-medium">{text}</span>
      ),
    },

    {
      title: <span className="text-[13px]">Actions</span>,
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-2">
          <Tooltip title="View">
            <Button
              icon={<BsEye />}
              onClick={() => showDrawer(record)}
              className="bg-[#1945E0] text-white hover:border-[#1955EB] hover:bg-[#1945E0]"
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <>

      <div className="flex justify-between items-center mb-4 flex-wrap gap-2 p-4 lg:p-6 md:p-5">
        <div className="flex border border-[#9FACF0] p-1.5 gap-1.5 rounded-[12px] w-max bg-white mt-4 mb-2">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              className={`h-10 px-6 whitespace-nowrap rounded-lg text-sm transition-all duration-200
        ${activeTab === tab.value
                  ? "bg-white text-[#1955EB] font-semibold shadow-sm border border-blue-100"
                  : "bg-transparent text-gray-500 hover:bg-gray-50 font-medium"
                }`}
              onClick={() => {
                setActiveTab(tab.value);
                setCurrentPage(1);
              }}
            >
              {tab.label} {tab.count}
            </button>
          ))}
        </div>
      </div>

      <div className="pt-[0px] space-y-10">
        <Spin spinning={loader}>
          <Table columns={columns} dataSource={user} pagination={false} />
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            limit={limit}
            totalItem={totalItems}
            onPageChange={handlePageChange}
            handleLimit={handleLimit}
          />
        </Spin>
      </div>
      <Modal
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        className=""
      >
        <div className="flex flex-col items-center py-3">
          <div className="flex items-center mb-4">
            <MdOutlineDone className="text-white p-1 rounded-full bg-[#3AB927] text-4xl" />
          </div>
          <div className="text-center text-[16px] font-medium">
            <p className="text-[#C7C7C7] text-[16px] font-medium">
              {currentUser?.name}
            </p>
            <p className="text-[#313131] text-[24px] font-medium ">
              Account Varified Successfully
            </p>
          </div>
          <div className="flex justify-center mt-3">
            <Button
              onClick={handleCancel}
              className="bg-[#313131] h-10 text-white text-[18px] font-medium"
            >
              Dismiss
            </Button>
          </div>
        </div>
      </Modal>

      {/* Reject Confirmation Modal */}
      <Modal
        title={`Reject ${rejectingUser?.name}'s Verification Request`}
        open={isRejectModalOpen}
        onCancel={handleRejectCancel}
        footer={[
          <Button key="cancel" onClick={handleRejectCancel}>
            Cancel
          </Button>,
          <Button key="reject" type="primary" danger onClick={handleReject}>
            Reject
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="rejectReason"
            label="Reason for rejection"
            rules={[
              {
                required: true,
                message: "Please provide a reason for rejection",
              },
              {
                min: 10,
                message: "Reason must be at least 10 characters long",
              },
            ]}
          >
            <TextArea
              rows={4}
              placeholder="Enter rejection reason..."
              className="mt-2"
            />
          </Form.Item>
        </Form>
      </Modal>
      <IndividualDrawer
        visible={drawerVisible}
        onClose={closeDrawer}
        user={selectedUser}
        showRejectConfirm={showRejectConfirm}
        showConfirm={showConfirm}
      />
    </>
  );
};

export default VarifyRequest;
